import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {bzIconFilter} from '@bringoz/ui/icons';
import {TimekeepingTotalsCard} from '../../models/timekeeping-list.model';
import {TimeCardDisplayStatusGroupType} from '../../../types/timecard-display-status-group.type';

require('./timekeeping-totals.scss');
@Component({
  standalone: false,
  selector: 'app-timekeeping-totals',
  templateUrl: './timekeeping-totals.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimekeepingTotalsComponent {

  readonly cards = input<TimekeepingTotalsCard[]>([]);
  readonly statusSelect = output<TimeCardDisplayStatusGroupType>();

  readonly filterIcon = bzIconFilter;
}
